export default {
  navBar: 'w-full max-w-[1440px] mx-auto px-[5vw] py-[22px] flex justify-between z-[9] bg-color-bg items-center',
  logoWrapper: 'cursor-pointer flex-[0_0_25%]',
  logo: 'h-[66px] object-contain',
  title: 'font-interSemibold text-[24px] text-[#101828] flex-1 flex justify-center',
  buttonWrapper: 'flex-[0_0_25%] flex justify-end',
  container: 'min-h-screen bg-color-bg p-[24px]',
  content: 'mx-auto w-full sm:w-[600px] bg-color-white rounded-2xl',
  contentHeader: 'px-[18px]',
  infoText: 'text-center font-inter p-[24px]',
};
